<template>
  <div>
    <br />
    <br />
    <br />
    <br />
    <br />
    <v-btn color="error" icon @click="toggleDiv" class="floating-button">
      <v-icon v-if="showDiv">arrow_back</v-icon>
      <v-icon v-else>arrow_forward</v-icon>
    </v-btn>
    <div class="pa-2">
      <div
        :class="showDiv ? 'show' : 'hide'"
        style="background: #eee; width: 195px; padding: 15px 15px 5px"
      >
        <v-btn
          small
          class="white--text caption w-165"
          color="error"
          @click="searchResponse"
        >
          <!-- <v-icon small class="mr-1">search</v-icon> -->
          Search in responses
        </v-btn>
        <v-btn
          small
          v-if="status == 6"
          class="white--text caption w-165"
          color="error"
          @click="download"
        >
          Download Responses
        </v-btn>
        <v-btn
          small
          v-if="status == 6 && downloads.download_project_image != null"
          class="white--text caption w-165"
          color="error"
          @click="downloadImage"
        >
          Download All Images
        </v-btn>
        <v-btn
          small
          v-if="status == 6 && downloads.download_project_audio != null"
          class="white--text caption w-165"
          color="error"
          @click="downloadAudio"
        >
          Download All Audios
        </v-btn>
        <v-btn
          small
          v-if="status == 6 && downloads.download_project_video != null"
          class="white--text caption w-165"
          color="error"
          @click="downloadVideo"
        >
          Download All Videos
        </v-btn>
        <v-btn
          small
          v-if="status == 6 && downloads.download_project_file != null"
          class="white--text caption w-165"
          color="error"
          @click="downloadFile"
        >
          Download All Files
        </v-btn>
      </div>
      <ProjectActionsResponseDialog
        :results="results"
        v-model="responseDialog"
        :stop="stop"
        @stopAction="stop = true"
        :total="selected.length"
      />
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import api from "../../api/datadash";
import ProjectActionsResponseDialog from "./ProjectActionsResponseDialog";
export default {
  components: { ProjectActionsResponseDialog },
  props: ["status", "selected", "downloads"],
  data() {
    return {
      results: [],
      responseDialog: false,
      stop: false,
      showDiv: false,
      // disabled: false,
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  methods: {
    searchResponse() {
      this.$router.push(`/${this.$route.params.id}/search-in-response`);
    },

    download() {
      window.open(this.downloads.excelUrl);
    },

    downloadImage() {
      // window.open(this.download_project_image);
      this.downloadFiles(
        "project-" + this.$route.params.id + "-image-files.zip",
        this.downloads.download_project_image
      );
    },

    downloadAudio() {
      this.downloadFiles(
        "project-" + this.$route.params.id + "-audio-files.zip",
        this.downloads.download_project_audio
      );
    },

    downloadVideo() {
      this.downloadFiles(
        "project-" + this.$route.params.id + "-video-files.zip",
        this.downloads.download_project_video
      );
    },
    downloadFile() {
      this.downloadFiles(
        "project-" + this.$route.params.id + "-files.zip",
        this.downloads.download_project_file
      );
    },

    downloadFiles(fileName, downloadUrl) {
      axios({
        url: downloadUrl,
        method: "GET",
        responseType: "blob",
        Authorization: `Bearer ${this.auth.token}`,
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", fileName);
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },

    toggleDiv() {
      this.showDiv = !this.showDiv;
    },
  },
};
</script>
<style scoped>
.floating-button {
  position: absolute;
  left: 0px;
  margin-top: -100px;
  z-index: 999; /* Adjust the z-index as needed */
}
.show {
  /* margin-left: 0;
    transition: transform 0.3s ease-in-out; */
  transform: translateX(0);
  margin-top: -65px;
  transition: transform 0.3s ease-in-out;
}
.hide {
  transform: translateX(-200%);
  margin-top: -65px;
  transition: transform 0.3s ease-in-out;
}
.w-165 {
  width: 165px;
  height: 28px;
  margin: 0 0 12px;
}
</style>
